const googleFormBaseURL = "https://docs.google.com/forms/d/e/";
const additionalQuery = "/viewform?usp=pp_url";

import objectMixin from "../mixins/objectMixin";
import numbertMixin from "../mixins/numberMixin";
import dateMixin from "../mixins/dateMixin";

const getValueOf = (obj, chain, def) =>
  objectMixin.methods.get(obj, chain, def);

const formatDate = (date, format = "DD/MM/YYYY HH:mm") =>
  dateMixin.filters.formatDate(date, format);

const amountToCurrency = amount => numbertMixin.filters.intToCurrency(amount);

const durationInHours = duration =>
  `${duration} hora${duration > 1 ? "s" : ""}`;

const orderDuration = order =>
  getValueOf(order, "schedule_event.duration") / 60;

const orderStartsAt = order =>
  formatDate(getValueOf(order, "schedule_event.starts_at"), "HH:mm");

function entriesToString(entries) {
  return entries.reduce(
    (acc, entry) => acc + `&entry.${entry.id}=${entry.value}`,
    ""
  );
}

function orderToInfringementEntries(order) {
  return [
    { id: "80642693", value: getValueOf(order, "id") },
    { id: "88325595", value: getValueOf(order, "professional.account.email") },
    { id: "159738188", value: getValueOf(order, "customer.account.email") },
    {
      id: "885115348",
      value: getValueOf(order, "address.district.city.display_name")
    },
    {
      id: "2009672768",
      value: getValueOf(order, "address.district.display_name")
    },
    { id: "475054342", value: durationInHours(orderDuration(order)) },
    { id: "174973190", value: orderStartsAt(order) },
    {
      id: "717393345",
      value: amountToCurrency(getValueOf(order, "amount.total"))
    },
    {
      id: "135552044",
      value: amountToCurrency(getValueOf(order, "amount.price"))
    }
  ];
}

function buildInfringementFormUrl(order) {
  const infringementFormId =
    "1FAIpQLSdDUs4IXWkDen6jkJa5EoNjsuFNxZbGJ9lMjDUWyq5FMsCMVQ";

  const orderInfringementEntries = orderToInfringementEntries(order);
  let entriesQuery = entriesToString(orderInfringementEntries);

  return `${googleFormBaseURL}${infringementFormId}${additionalQuery}${entriesQuery}`;
}

function orderToDelayEntries(order) {
  return [
    { id: "780987804", value: getValueOf(order, "id") },
    { id: "431681256", value: getValueOf(order, "professional.account.email") },
    { id: "1779128032", value: getValueOf(order, "customer.account.email") },
    {
      id: "1492293033",
      value: getValueOf(order, "address.district.city.display_name")
    },
    {
      id: "990255290",
      value: getValueOf(order, "address.district.display_name")
    },
    { id: "318863600", value: durationInHours(orderDuration(order)) },
    { id: "308249508", value: orderStartsAt(order) }
  ];
}

function buildDelayFormUrl(order) {
  const infringementFormId =
    "1FAIpQLSfsZZ8TdKjjPbJsOXEvXM7DXRHu8rRbxbDdPcdhxlO5paQh8w";

  const orderInfringementEntries = orderToDelayEntries(order);
  let entriesQuery = entriesToString(orderInfringementEntries);

  return `${googleFormBaseURL}${infringementFormId}${additionalQuery}${entriesQuery}`;
}

function resourceToBlockedAmountEntries(accountable, amount) {
  return [
    { id: "230587520", value: getValueOf(accountable, "account.email") },
    {
      id: "889615866",
      value: getValueOf(accountable, "account.profile.city_name")
    },
    { id: "1096180785", value: amount }
  ];
}

function orderToCancellationEntries(order) {
  return [
    { id: "1993896070", value: getValueOf(order, "id") },
    {
      id: "1630571762",
      value: getValueOf(order, "professional.account.email")
    },
    { id: "485135247", value: getValueOf(order, "customer.account.email") },
    {
      id: "665602611",
      value: getValueOf(order, "address.district.city.display_name")
    },
    {
      id: "1159553784",
      value: getValueOf(order, "address.district.display_name")
    },
    { id: "2017129624", value: durationInHours(orderDuration(order)) },
    { id: "12678327", value: orderStartsAt(order) }
  ];
}

function buildCancellationFormURL(order) {
  const cancellationFormId =
    "1FAIpQLSenP8q9RCgkJoN6Jq2YgsPKiV2-blBNuJ3s9BZJ8IB1VQiBNg";

  const cancellationEntries = orderToCancellationEntries(order);
  let entriesQuery = entriesToString(cancellationEntries);

  return `${googleFormBaseURL}${cancellationFormId}${additionalQuery}${entriesQuery}`;
}

function buildBlockedAmountFormUrl(resource) {
  const { accountable, amount } = resource;
  const blockedAmountFormId =
    "1FAIpQLScGqUWeDiLr-qCmljvRKioTDFPS3VwfIk02-vqc5N6LOycTKQ";

  const blockedAmountEntries = resourceToBlockedAmountEntries(
    accountable,
    amount
  );
  let entriesQuery = entriesToString(blockedAmountEntries);

  return `${googleFormBaseURL}${blockedAmountFormId}${additionalQuery}${entriesQuery}`;
}

function buildGoogleFormsURL(formType, resource) {
  switch (formType) {
    case "infringementForm":
      return buildInfringementFormUrl(resource);
      break;

    case "delayForm":
      return buildDelayFormUrl(resource);
      break;

    case "blockedAmountForm":
      return buildBlockedAmountFormUrl(resource);
      break;

    case "cancellationForm":
      return buildCancellationFormURL(resource);
      break;

    default:
      break;
  }
}

export default {
  buildGoogleFormsURL
};



// WEBPACK FOOTER //
// ./src/utils/googleForms.js